module.exports = __webpack_public_path__ + "static/a-xx-221-art-236f515577d0c1af951cfbbcfe5b6ef2.jpg";